module.exports = __webpack_public_path__ + "img/design_decogaia.ea580379.jpg";